export default __webpack_public_path__ + "static/CircularStd-Bold-723832f6d0d253821c078ca2876d89b7.ttf";